import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import NumberFormat from 'react-number-format';
import TextField from '@material-ui/core/TextField';
import ReactSelect from 'react-select';
import { components } from '../../../Utils/ReactSelectComponents';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import InputLabel from '@material-ui/core/InputLabel';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import green from '@material-ui/core/colors/green';
import DropdownListAPI from '../../../../API/DropdownListAPI';
import RUReservationAPI from '../../../../API/UsedRentalsReservationAPI';
import SnackbarAlert from '../../../Utils/SnackbarAlert';
import { handleServerError } from '../../../../Utils/Helper';


const modalStyles = theme => ({
  paper: {
    position: 'absolute',
    width: '50%',
    minWidth: 240,
    backgroundColor: theme.palette.background.paper
  },
  toolbarRoot: {
    padding: 0,
    backgroundColor: '#004A5D'
  },
  titleHead: {
    margin: '4px 12px',
    color: '#ffffff'
  },
  iconRight: {
    position: 'absolute',
    right: '12px',
    marginTop: '45px'
  },
  formRoot: {
    flexGrow: 1,
    margin: '12px'
  },
  width100: {
    width: '100%'
  },
  footer: {
    display: 'flex',
    position: 'relative'
  },
  buttonSuccess: {
    backgroundColor: green[400],
    '&:hover': {
      backgroundColor: green[600],
    },
  },
  fabProgress: {
    position: 'absolute',
    right: 2,
    bottom: 2,
    zIndex: 1
  },
  button: {
    margin: theme.spacing.unit,
  },
  buttonSize: {
    width: '36px',
    height: '36px'
  },
  //DON'T REMOVE (Used in ReactSelectComponents)
  noOptionsMessage: {
    padding: `${theme.spacing.unit / 2}px`
  },
  input: {
    display: 'flex',
    padding: 0
  }
});

function getModalPosition() {
  return {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  };
}

function InputNumber(props) {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({ target: { value: values.value } });
      }}
      allowNegative={false}
      fixedDecimalScale
      decimalScale={0}
      maxLength={3}
    />
  );
}

export class RUReservationsExtendCancelModal extends Component {
  _isMounted = false;
  dropdownListDataAPI;
  dataAPI;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      success: false,
      extensionReasonsData: [],
      cancellationReasonsData: [],
      choosenReason: [],
      carExtendDays: 0,
      isUR_GROUP: false,
      openError: false,
      alertMessage: ''
    };
    this.dataAPI = new RUReservationAPI();
    this.dropdownListDataAPI = new DropdownListAPI();
  }

  componentDidMount() {
    this._isMounted = true;
    Promise.all([this.dropdownListDataAPI.getAllExtensionReasons(), this.dropdownListDataAPI.getAllCancellationReasons()]).then((response) => {
      if (this._isMounted)
        this.setState({
          extensionReasonsData: response[0].data,
          cancellationReasonsData: response[1].data,
          loading: false
        });
    }).catch((error) => {
      if (this._isMounted)
        this.setState({
          openError: true,
          alertMessage: handleServerError(error)
        });
    });
  };

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleChangeSelect = name => value => {
    this.setState({ [name]: value });
  };

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  };

  handleClose = () => {
    this.props.handleClose();
    this.setState({
      loading: false,
      success: false,
      choosenReason: []
    });
  };

  handleSubmitCancelReservation = () => {
    this.setState({ loading: true });
    this.dataAPI.cancelRUReservation(this.props.carReservationId, this.state.choosenReason.value).then(() => {
      if (this._isMounted) {
        this.setState({
          loading: false,
          success: true
        });
        setTimeout(() => {
          this.handleClose();
          this.props.reloadTable();
          this.props.detectCancellation();
        }, 500);
      }
    }).catch((error) => {
      if (this._isMounted)
        this.setState({
          loading: false,
          success: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
      this.handleClose();
    });
  };

  handleSubmitExtendReservation = () => {
    this.setState({ loading: true });
    this.dataAPI.extendRUReservation(this.props.carReservationId, this.state.choosenReason.value, this.state.carExtendDays).then(() => {
      if (this._isMounted) {
        this.setState({
          loading: false,
          success: true
        });
        setTimeout(() => {
          this.handleClose();
          this.props.reloadTable();
        }, 500);
      }
    }).catch((error) => {
      if (this._isMounted)
        this.setState({
          loading: false,
          success: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
      this.handleClose();
    });
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      alertMessage: ''
    });
  };


  render() {
    const { classes } = this.props;
    const { loading, success, extensionReasonsData, cancellationReasonsData } = this.state;
    const buttonClassname = classNames({ [classes.buttonSuccess]: success });

    return (
      <React.Fragment>

        <Modal key={'0'} open={this.props.openModal} onClose={this.handleClose} disableAutoFocus={true}>
          <div style={getModalPosition()} className={classes.paper}>

            <Paper>
              <Toolbar className={classes.toolbarRoot}>
                <Typography variant='title' className={classes.titleHead}>
                  {this.props.openReasonsTitle}
                </Typography>
              </Toolbar>
            </Paper>

            <form className={classes.formRoot}>
              {(this.props.carExtendDays <= 0 && this.props.isUR_GROUP && this.props.openReasons === 'Extension') ?
                <Grid container spacing={8}>
                  <Grid item xs={12} sm={6}>
                    <Grid container justify='center'>
                      <div className={classes.width100}>
                        <InputLabel>
                          PROLONGAMENTO (em dias)
                        </InputLabel>
                        <TextField
                          id='carExtendDays'
                          fullWidth
                          className={classes.alignTextfield}
                          value={this.state.carExtendDays}
                          onChange={this.handleChange('carExtendDays')}
                          InputProps={{ inputComponent: InputNumber }}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
                : null
              }
              <Grid container spacing={8}>
                <Grid item xs={12} sm={12}>
                  <Grid container justify='center'>
                    <div className={classes.width100}>
                      <InputLabel>
                        MOTIVOS DE {this.props.openReasons === 'Extension' ? 'PROLONGAMENTO' : 'CANCELAMENTO'}
                      </InputLabel>
                      <ReactSelect
                        classes={classes}
                        options={this.props.openReasons === 'Extension' ? extensionReasonsData : cancellationReasonsData}
                        components={components}
                        value={this.state.choosenReason}
                        onChange={this.handleChangeSelect('choosenReason')}
                        placeholder=''
                      />
                    </div>
                  </Grid>
                </Grid>
              </Grid>

              <Toolbar className={classes.footer}>
                <div className={classes.iconRight}>
                  <Tooltip title='Cancelar' placement='bottom' >
                    <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.handleClose.bind(this)}>
                      <CloseIcon />
                    </Button>
                  </Tooltip>
                  <Tooltip title='Confirmar' placement='bottom' >
                    <Button disabled={loading} variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize, buttonClassname)} onClick={this.props.openReasons === 'Extension' ? this.handleSubmitExtendReservation : this.handleSubmitCancelReservation}>
                      <CheckIcon />
                      {success}
                    </Button>
                  </Tooltip>
                  {loading && <CircularProgress size={48} color='primary' className={classes.fabProgress} />}
                </div>
              </Toolbar>

            </form>
          </div>
        </Modal>

        <SnackbarAlert key={'1'} openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

      </React.Fragment>
    );
  }
}

RUReservationsExtendCancelModal.propTypes = {
  classes: PropTypes.object.isRequired
};

export default RUReservationsExtendCancelModal = withStyles(modalStyles)(RUReservationsExtendCancelModal);


// WEBPACK FOOTER //
// ./src/components/UsedRentals/UsedRentalsReservations/UsedRentalsAllReservations/RUReservationsExtendCancelModal.js